import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  // Auth
  login: (email, password) => axios.post(`${API}/auth/login`, { email, password }),
  register: (userData) => axios.post(`${API}/auth/register`, userData),
  getMe: () => axios.get(`${API}/auth/me`),

  // Diamonds (public)
  getPublicDiamonds: () => axios.get(`${API}/diamonds/public`),
  getPublicDiamond: (id) => axios.get(`${API}/diamonds/${id}/public`),

  // Diamonds (authenticated)
  getDiamonds: () => axios.get(`${API}/diamonds`),
  getDiamond: (id) => axios.get(`${API}/diamonds/${id}`),
  createDiamond: (data) => axios.post(`${API}/diamonds`, data),
  updateDiamond: (id, data) => axios.put(`${API}/diamonds/${id}`, data),
  deleteDiamond: (id) => axios.delete(`${API}/diamonds/${id}`),

  // Users (admin)
  getPendingUsers: () => axios.get(`${API}/users/pending`),
  getAllUsers: () => axios.get(`${API}/users`),
  approveUser: (userId) => axios.put(`${API}/users/${userId}/approve`),
  rejectUser: (userId) => axios.put(`${API}/users/${userId}/reject`),
  updateUserStatus: (userId, status) => axios.put(`${API}/users/${userId}/status?status=${status}`),

  // Upload
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API}/diamonds/upload-media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const generateWhatsAppLink = (diamond) => {
  const message = `Hi, I'm interested in the ${diamond.shape} diamond (${diamond.size} carat, ${diamond.colour} ${diamond.clarity}). Diamond ID: ${diamond.diamond_id}`;
  const phone = '+918128741058';
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
};